module.exports = __webpack_public_path__ + "img/articleComplete.5407322c.svg";